import styled from "styled-components";

const Section = styled.section`
  margin-bottom: ${props => props.spacing || "14rem"};
  padding: 0 1rem;
`;

export default Section;
